export default __webpack_public_path__ + "static/iphone-mock-abf2e83f40858cf42bdf25901fd4108a.png";